/* eslint-disable no-unused-vars */

import React, { useState } from "react";
import Body from "./Body";
import { ReactComponent as BsBoxArrowRight } from "../../../../../assets/Icons/Universal/BsBoxArrowRight.svg";

const AccommodationMaintenance = () => {
  const [isReceiptOpen, setIsReceiptOpen] = useState(false);
  const handleReceiptClick = (row, receiptIndex) => {
    console.log("Clicked receipt", receiptIndex, "for row:", row);
    // Example: open modal, generate receipt PDF, etc.
  };
  const historyData = [
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      accommodation: "New bed arriving",
      date: "02 oct, 2025",
      description:
        "Inspection is near about two hours within a campus. Mainly school building. It touches a world class standard.",
      amount: 18000,
      paidAmount: 18000,
      paymentMethod: "UPI",
      mentor: "Mahi Enterprise",
      phone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      status: "Pay due",
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      accommodation: "New bed arriving",
      date: "02 oct, 2025",
      description:
        "Inspection is near about two hours within a campus. Mainly school building.",
      amount: 18000,
      paidAmount: 36000,
      paymentMethod: "Net banking",
      mentor: "Mahi Enterprise",
      phone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      status: "All paid",
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      accommodation: "New bed arriving",
      date: "02 oct, 2025",
      description:
        "Inspection is near about two hours within a campus. Mainly school building.",
      amount: 18000,
      paidAmount: 18000,
      paymentMethod: "Debit card",
      mentor: "Mahi Enterprise",
      phone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      status: "Pay due",
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      accommodation: "New bed arriving",
      date: "02 oct, 2025",
      description:
        "Inspection is near about two hours within a campus. Mainly school building. It touches a world class standard.",
      amount: 18000,
      paidAmount: 18000,
      paymentMethod: "Cash",
      mentor: "Mahi Enterprise",
      phone: "9876543210",
      confirmedBy: "Jaheer Ahmad",
      status: "Pay due",
    },
  ];

  const columns = [
    {
      key: "receiptId",
      label: "Receipt id/Time",
      minWidth: "140px",
      render: (row) => (
        <div>
          <div>{row.receiptId}</div>
          <div style={{ color: "#F29339", fontSize: "0.85em" }}>{row.time}</div>
        </div>
      ),
    },
    {
      key: "accommodation",
      label: "Accommodation details",
      minWidth: "150px",
      render: (row) => (
        <div>
          <div>{row.accommodation}</div>
          <div style={{ color: "#5D87FF", fontSize: "0.85em" }}>{row.date}</div>
        </div>
      ),
    },
    {
      key: "description",
      label: "Description",
      minWidth: "220px",
    },
    {
      key: "amount",
      label: "Total amount (INR)",
      render: (row) => <span>₹ {row.amount.toLocaleString()}</span>,
    },
    {
      key: "paidAmount",
      label: "Paid amount (INR)",
      render: (row) => (
        <div>
          <div>₹ {row.paidAmount.toLocaleString()}</div>
          <div style={{ color: "#4CAF50", fontSize: "0.85em" }}>
            {row.paymentMethod}
          </div>
        </div>
      ),
    },
    {
      key: "mentor",
      label: "Mentor/event",
      render: (row) => (
        <div>
          <div>{row.mentor}</div>
          <div>
            Ph: <span style={{ color: "#5D87FF" }}>{row.phone}</span>
          </div>
        </div>
      ),
    },
    {
      key: "confirmedBy",
      label: "Confirmed by",
    },
    {
      key: "receipts",
      label: "Receipts",
      render: (row) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {/* {row.receipts.map((receipt, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <span
                onClick={() => handleReceiptClick(row, i)}
                style={{
                  color: "#5D87FF",
                  cursor: "pointer",
                  fontWeight: 500,
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                Receipt
                <BsBoxArrowRight />
              </span>
              {receipt.status && (
                <span
                  style={{
                    fontSize: "12px",
                    padding: "2px 8px",
                    backgroundColor:
                      receipt.status === "All paid" ? "#4CAF50" : "#F29339",
                    color: "white",
                    borderRadius: "4px",
                  }}
                >
                  {receipt.status}
                </span>
              )}
            </div>
          ))} */}
        </div>
      ),
    },
  ];

  const _this = { columns, historyData, isReceiptOpen, setIsReceiptOpen };
  return <Body {..._this} />;
};

export default AccommodationMaintenance;
